import {Component,OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";
import {BoiteLienService} from "@components/admin/parametre/personnalisation/boite-lien/boite-lien.service";

/**
 * Composant d'affichage de la pageBoiteLien
 *
 * @author Lionel Gimenez
 * @date 15/07/2025
 */
@Component({
    host: {'data-test-id': 'boite-lien'},
    selector: 'boite-lien',
    templateUrl: './boite-lien.component.html'
})
export class BoiteLienComponent implements OnInit {
    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(
        public boiteLienService: BoiteLienService,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        this.boiteLienService.initListView();

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-ajouter',
            libelle: 'global.actions.creer',
            doAction: () => this.create(),
        }]);
    }

    /**
     * Ouvre la modale pour la création du modèle
     */
    create(): void {
        this.boiteLienService.openDialog(null).subscribe(refresh => {
            if (refresh) {
                //On met à jour la liste
                this.boiteLienService.refresh();
            }
        });
    }
}